import { FC, SVGProps } from 'react';

const CallsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" {...props} fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.60995 10.3936C12.9342 13.7169 13.6883 9.87224 15.8049 11.9873C17.8454 14.0273 19.0182 14.436 16.4329 17.0206C16.109 17.2808 14.0515 20.4119 6.82066 13.183C-0.411069 5.95331 2.71815 3.89368 2.97847 3.56994C5.57005 0.978185 5.97171 2.1578 8.01224 4.19775C10.1288 6.31373 6.28571 7.07032 9.60995 10.3936Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CallsIcon;
